module.exports = __webpack_public_path__ + "static/img/gong_icon_lightblue.4a99ada.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/gong_icon_lightblue.png
// module id = BWSC
// module chunks = 19